import { isRecord } from "../types/data";
import { useEffect, useState } from "react";
import { RATING_PROGRESS_MODE_EVENT } from "../utility/ratingProgressMode";
import { useI18n } from "../i18n/useI18n";

type RatingProgressMode = "archive" | "current";

function RatingProgressModeModal() {
  const { t } = useI18n();
  const [request, setRequest] = useState<{ resolve?: (mode: RatingProgressMode) => void } | null>(null);

  useEffect(() => {
    const handleRequest = (event: Event) => {
      const detail: unknown = event instanceof CustomEvent ? event.detail : null;
      const resolve = isRecord(detail) ? detail.resolve : undefined;
      setRequest({ resolve: typeof resolve === "function" ? mode => { resolve(mode); } : undefined });
    };
    window.addEventListener(RATING_PROGRESS_MODE_EVENT, handleRequest);
    return () => window.removeEventListener(RATING_PROGRESS_MODE_EVENT, handleRequest);
  }, []);

  if (!request) return null;

  const chooseMode = (mode: RatingProgressMode) => {
    request.resolve?.(mode);
    setRequest(null);
  };

  return (
    <div className="rating-mode-modal" role="dialog" aria-modal="true">
      <div className="rating-mode-modal__panel">
        <p>{t("Вы добавляете много фильмов подряд.")}</p>
        <p>{t("Выберите, как учитывать сегодняшние оценки в прогрессе.")}</p>
        <h3>{t("Режим на сегодня:")}</h3>
        <div className="rating-mode-modal__actions">
          <button type="button" onClick={() => chooseMode("archive")}>
            {t("Перенос старых оценок")}
          </button>
          <button type="button" onClick={() => chooseMode("current")}>
            {t("Я реально смотрю эти фильмы сейчас")}
          </button>
        </div>
        <p className="rating-mode-modal__hint">
          {t("Выбор сохранится до конца дня. Перенос не влияет на серии и недельные бонусы.")}
        </p>
      </div>
    </div>
  );
}

export default RatingProgressModeModal;
